<template>
<div v-loading="exportLoading" element-loading-text="正在校验卡">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form>
            <el-form-item>
                <el-button type="primary" @click="exportTable()" style="margin-right:20px;">批量充值叠加包</el-button>
                <el-select v-model="packagecode" placeholder="请选择叠加包" clearable style="margin-right:20px;" @change="selectChange">
                    <el-option
                    v-for="item in options"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                    </el-option>
                </el-select> 
                <el-input-number v-model="buyNum" :min="1" v-show="buyNumShow"></el-input-number>
                <span style="color:red;margin-left:5px;" v-show="buyNumShow"><i class="el-icon-warning-outline"></i>购买数量</span>
            </el-form-item>
        </el-form>
    </el-col>
    <el-input type="textarea" :rows="20" :placeholder="placeholder" v-model="textarea" class="textexport">
    </el-input>

    <!--充值弹框界面-->
    <el-dialog title="批量充值信息" :visible.sync="isrecharge" width="60%" :close-on-click-modal="false">
        <el-row>
            <el-col :span="24">
                <!--列表(查询结果-当前页)row-style="height:12px;"-->
                <el-table :data="bathRechargeInfo" highlight-current-row v-loading="listLoading" style="width: 100%;line-height:22px;" height="450" border >
                    <el-table-column prop="msisdn" label="卡号" width="130" sortable>
                    </el-table-column>
                    <el-table-column prop="iccid" label="ICCID" width="180">
                    </el-table-column>
                    <el-table-column prop="addPackageName" label="套餐名称" min-width="180">
                    </el-table-column>
                    <el-table-column prop="addgprssize" label="叠加包大小(M)" min-width="100">
                    </el-table-column>
                    <el-table-column prop="addgprsprice" label="叠加包价格(元)" min-width="100">
                    </el-table-column>
                    <el-table-column prop="addgprscount" label="购买数量" min-width="80">
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row style="line-height:32px;margin-top:15px;">
            <!--工具条(分页)-->
            <el-col :span="8">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next" :total="total" style="padding-top:2px;">
                </el-pagination>
            </el-col>
            <el-col :span="9">
                <div style="font-weight:bold;">本次共充值：<span style="color:red;font-size:17px"> {{this.total}} </span>张卡，总金额：<span style="color:red;font-size:17px"> {{this.rechargePrice}} </span>元 </div>
            </el-col>
            <el-col :span="7" style="text-align:right;">
                <el-button type="primary" size="small" @click.native="exportRechage()">&nbsp;&nbsp;&nbsp;导 出&nbsp;&nbsp;&nbsp;</el-button>
                <el-button type="primary" size="small" @click.native="toRecharge()">立即充值</el-button>
            </el-col>
        </el-row>
    </el-dialog>

    <cardqrcode ref="cardqrcode" style="padding-left:0px"></cardqrcode>
</div>
</template>

<script>
import {
    bathBuyFlow,
    getGprsFlowPackage,
    getAlladdGprsFlowInfo,
    getAddGprsFlowPrice
} from '../../api/api'
import CardQrcode from '../../components/batch_buyflow.vue';
export default {
    components: {
        cardqrcode: CardQrcode
    },
    data() {
        return {
            textarea: '',
            currmonthflowlimit:'',
            exportLoading: false,
            placeholder : "请粘贴要购买流量包的卡号列表(每一条一行)",
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            isrecharge: false, //批量入库界面是否显示
            listLoading: false,
            options: [],
            bathRechargeInfo: [],
            rechargePrice: 0,
            buyNum: 1,
            packagecode: null,
            buyNumShow: false,
        }
    },
    created() {
        this.getGprsFlowPackage();
    },
    methods: {
        exportTable() {

            if (this.textarea.trim() == "") {
                this.$message({
                    message: '卡信息不能为空',
                    type: 'error'
                });
            } else {
                if(this.packagecode == null || this.packagecode == ''){
                    this.$message({
                        message: '请选择叠加包',
                        type: 'error'
                    });
                    return;
                }
                if(this.buyNum == null){
                    this.$message({
                        message: '请选择购买数量',
                        type: 'error'
                    });
                    return;
                }
                let para = {
                    cardinfo: this.textarea.trim(),
                    packagecode : this.packagecode,
                    buyNum : this.buyNum
                }
                this.exportLoading = true;
                bathBuyFlow(para).then((res) => {
                    if(res.code==0){
                        this.exportLoading=false;
                        this.textarea=res.msg;

                        this.orderId = res.data;

                        //展示列表信息
                        this.isrecharge = true;
                        this.getrecharge();
                        //计算最终要充值的金额
                        this.getTotalAndOrderId();
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.exportLoading=false;
                    }
                });
            }
        },
        getrecharge() {

            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                orderid: this.orderId
            };
            this.listLoading = true;
            getAlladdGprsFlowInfo(para).then((res) => {
                this.total = res.data.total;
                this.bathRechargeInfo = res.data.list;
                this.listLoading = false;
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getrecharge();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getrecharge();
        },
        getTotalAndOrderId() {
            let para = {
                orderid: this.orderId
            }
            //获取总金额和订单编号
            getAddGprsFlowPrice(para).then((res) => {
                this.rechargePrice = res.data.rechargePrice;
                //this.orderId = res.data.orderId;
            });
        },
        getGprsFlowPackage() {
            getGprsFlowPackage({}).then((res) => {
                this.options = res.data;
            });
        },
        exportRechage() {
            let para = "";
            para += "orderid=" + this.orderId;

            location.href = "/api/tRechargeTemp/exportAddGprsXls?"+para;
        },
        toRecharge() {
            if (this.rechargePrice <= 0) {
                this.$message({
                    message: '充值总金额为0，不能充值,请核实',
                    type: 'error'
                });
                return;
            }
            // var tishi="本次共充值"：+this.total}+张，总金额：<span style="color:red">{{this.rechargePrice}}</span>元
            this.isrecharge = false;
            this.$refs.cardqrcode.showCardQrcode(this.orderId, this.rechargePrice, this.total);
        },
        selectChange(value) {
            this.buyNum = 1;
            if(value != null && value != ''){
                this.buyNumShow = true;
            }else{
                this.buyNumShow = false;
            }
        }
    }

}
</script>  

<style>
.textexport {
    margin-top: 10px;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// batch_addgprssize.vue?38a7ae81